import React from 'react'
import PropTypes from 'prop-types'
import { Translation } from 'react-i18next'
import { withStyles } from '@material-ui/styles'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import SortableTable from '../../../utils/sortableTable'
import ContractRowContainer from '../../../containers/employer/contract/contractRow.container'
import moment from 'moment'

class ContractComponent extends React.Component {
  componentDidMount() {
    this.props.getLightEntrepreneurs()
    this.props.getEmployerContractList()
    this.props.getTotalApplications()
  }
  render() {
    return <Contract {...this.props} />
  }
}

const styles = () => ({
  select: {
    lineHeight: '1',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    width: '300px'
  }
})

const Contract = ({ classes, lightEntre, contractRowsData }) => {
  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            {lightEntreSelection(lightEntre, t, classes)}
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('employer.contract.h1')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-lg-12">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">{t('employer.contract.p')}</h3>
                  </div>
                  <div className="panel-body pd-0">
                    <SortableTable
                      data={contractRowsData}
                      createRowComponent={contractRows}
                      headerCells={contractCell}
                      enableFilters={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

function lightEntreSelection(data, t, classes) {
  const [selectedEmail, setSelectedEmail] = React.useState('') // Initial value
  const handleChange = (event) => {
    setSelectedEmail(event.target.value)
  }

  return (
    <FormControl>
      <InputLabel className={classes.select}>
        {t('employer.contract.label1')}
      </InputLabel>
      <Select
        className={classes.select}
        value={selectedEmail}
        onChange={handleChange}
      >
        <MenuItem value=""></MenuItem>
        {data.map((item, index) => (
          <MenuItem key={index} value={item.email}>
            {item.email}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

const contractCell = [
  {
    id: 'contract_id',
    label: 'employer.contract.fld1',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'string'
    }
  },
  {
    id: 'start_date',
    label: 'employer.contract.fld2',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'dateFrom'
    }
  },
  {
    id: 'end_date',
    label: 'employer.contract.fld3',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'dateTo'
    }
  },
  {
    id: 'status',
    label: 'employer.contract.fld4',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'action',
    label: '',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  }
]

const contractRows = (contract, index) => {
  return (
    <ContractRowContainer
      index={index}
      key={index}
      contract_num={contract.agreement_id}
      start_date={moment(contract.assignment_begins).format('DD.MM.YYYY')}
      end_date={moment(contract.assignment_ends).format('DD.MM.YYYY')}
      status={contract.agreement_status}
      contractData={contract}
    />
  )
}

ContractComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ContractComponent)
